import deleteShareObject from 'api/ShareObject/deleteShareObject';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export default function useRemoveShareObject() {
    const client = useClient();
    const params = useParams();
    const { openAlert } = useAlert();
    const [removeLoading, setLoading] = useState(false);
    const removeShareObject = async () => {
        setLoading(true);
        try {
            if (params.uri) {
                const response = await client.mutate(
                    deleteShareObject(params.uri),
                );
                if (!response.errors) {
                    openAlert({
                        message: 'Succesfully deleted Share Object',
                        severity: 'success',
                        path: '-1',
                    });
                } else {
                    openAlert({
                        message: `Error could not delete Share Object. ${response.errors[0]?.message}`,
                        severity: 'alert',
                    });
                }
            }
        } finally {
            setLoading(false);
        }
    };
    return { removeShareObject, removeLoading };
}
